import * as types from './_actionTypes';

export const fetchCourseContentsRequest = (courseId, params = {}) => ({
  type: types.FETCH_COURSE_CONTENTS_REQUEST,
  payload: { courseId, params }
});

export const fetchCourseContentsSuccess = (contents) => ({
  type: types.FETCH_COURSE_CONTENTS_SUCCESS,
  payload: contents
});

export const fetchCourseContentsFailure = (error) => ({
  type: types.FETCH_COURSE_CONTENTS_FAILURE,
  payload: error
});

// Fetch single content
export const fetchCourseContentRequest = (contentId) => ({
  type: types.FETCH_COURSE_CONTENT_REQUEST,
  payload: contentId
});

export const fetchCourseContentSuccess = (content) => ({
  type: types.FETCH_COURSE_CONTENT_SUCCESS,
  payload: content
});

export const fetchCourseContentFailure = (error) => ({
  type: types.FETCH_COURSE_CONTENT_FAILURE,
  payload: error
});

// Create content
export const createCourseContentRequest = (courseId, contentData) => ({
  type: types.CREATE_COURSE_CONTENT_REQUEST,
  payload: { courseId, contentData }
});

export const createCourseContentSuccess = (content) => ({
  type: types.CREATE_COURSE_CONTENT_SUCCESS,
  payload: content
});

export const createCourseContentFailure = (error) => ({
  type: types.CREATE_COURSE_CONTENT_FAILURE,
  payload: error
});

// Update content
export const updateCourseContentRequest = (contentId, updateData) => ({
  type: types.UPDATE_COURSE_CONTENT_REQUEST,
  payload: { contentId, updateData }
});

export const updateCourseContentSuccess = (content) => ({
  type: types.UPDATE_COURSE_CONTENT_SUCCESS,
  payload: content
});

export const updateCourseContentFailure = (error) => ({
  type: types.UPDATE_COURSE_CONTENT_FAILURE,
  payload: error
});

// Delete content
export const deleteCourseContentRequest = (contentId) => ({
  type: types.DELETE_COURSE_CONTENT_REQUEST,
  payload: contentId
});

export const deleteCourseContentSuccess = (contentId) => ({
  type: types.DELETE_COURSE_CONTENT_SUCCESS,
  payload: contentId
});

export const deleteCourseContentFailure = (error) => ({
  type: types.DELETE_COURSE_CONTENT_FAILURE,
  payload: error
});

// Reorder contents
export const reorderCourseContentsRequest = (courseId, newOrder) => ({
  type: types.REORDER_COURSE_CONTENTS_REQUEST,
  payload: { courseId, newOrder }
});

export const reorderCourseContentsSuccess = (contents) => ({
  type: types.REORDER_COURSE_CONTENTS_SUCCESS,
  payload: contents
});

export const reorderCourseContentsFailure = (error) => ({
  type: types.REORDER_COURSE_CONTENTS_FAILURE,
  payload: error
});

// Fetch content statistics
export const fetchCourseContentStatsRequest = (courseId) => ({
  type: types.FETCH_COURSE_CONTENT_STATS_REQUEST,
  payload: courseId
});

export const fetchCourseContentStatsSuccess = (stats) => ({
  type: types.FETCH_COURSE_CONTENT_STATS_SUCCESS,
  payload: stats
});

export const fetchCourseContentStatsFailure = (error) => ({
  type: types.FETCH_COURSE_CONTENT_STATS_FAILURE,
  payload: error
});

// Mux Video Upload Actions
export const uploadMuxVideoRequest = (file) => ({
  type: types.UPLOAD_MUX_VIDEO_REQUEST,
  payload: file
});

export const uploadMuxVideoSuccess = (videoUrl) => ({
  type: types.UPLOAD_MUX_VIDEO_SUCCESS,
  payload: videoUrl
});

export const uploadMuxVideoFailure = (error) => ({
  type: types.UPLOAD_MUX_VIDEO_FAILURE,
  payload: error
});

// Utility actions
export const clearCourseContentError = () => ({
  type: types.CLEAR_COURSE_CONTENT_ERROR
});

export const resetCourseContentState = () => ({
  type: types.RESET_COURSE_CONTENT_STATE
});






















